import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cf143440 = () => interopDefault(import('../src/pages/contribute.vue' /* webpackChunkName: "pages/contribute" */))
const _7e74882c = () => interopDefault(import('../src/pages/cookies.vue' /* webpackChunkName: "pages/cookies" */))
const _688fff1a = () => interopDefault(import('../src/pages/cookies-en.vue' /* webpackChunkName: "pages/cookies-en" */))
const _d0df1ba2 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6c4d080c = () => interopDefault(import('../src/pages/events.vue' /* webpackChunkName: "pages/events" */))
const _51aac373 = () => interopDefault(import('../src/pages/internal/index.vue' /* webpackChunkName: "pages/internal/index" */))
const _3db944a5 = () => interopDefault(import('../src/pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _ef0e77fe = () => interopDefault(import('../src/pages/privacy-en.vue' /* webpackChunkName: "pages/privacy-en" */))
const _e7aa80d0 = () => interopDefault(import('../src/pages/refunds.vue' /* webpackChunkName: "pages/refunds" */))
const _104b802e = () => interopDefault(import('../src/pages/refunds-en.vue' /* webpackChunkName: "pages/refunds-en" */))
const _418e3064 = () => interopDefault(import('../src/pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _6f4ecbe2 = () => interopDefault(import('../src/pages/terms-en.vue' /* webpackChunkName: "pages/terms-en" */))
const _10241b28 = () => interopDefault(import('../src/pages/thankyou.vue' /* webpackChunkName: "pages/thankyou" */))
const _cc05e856 = () => interopDefault(import('../src/pages/u/index.vue' /* webpackChunkName: "pages/u/index" */))
const _e3de1878 = () => interopDefault(import('../src/pages/where.vue' /* webpackChunkName: "pages/where" */))
const _0aaf8306 = () => interopDefault(import('../src/pages/internal/deletions.vue' /* webpackChunkName: "pages/internal/deletions" */))
const _15064170 = () => interopDefault(import('../src/pages/internal/events.vue' /* webpackChunkName: "pages/internal/events" */))
const _7385673a = () => interopDefault(import('../src/pages/internal/export.vue' /* webpackChunkName: "pages/internal/export" */))
const _7bc9b9ce = () => interopDefault(import('../src/pages/internal/home.vue' /* webpackChunkName: "pages/internal/home" */))
const _2e0d03e6 = () => interopDefault(import('../src/pages/internal/list.vue' /* webpackChunkName: "pages/internal/list" */))
const _1b52668a = () => interopDefault(import('../src/pages/internal/login.vue' /* webpackChunkName: "pages/internal/login" */))
const _808a07f6 = () => interopDefault(import('../src/pages/internal/membership.vue' /* webpackChunkName: "pages/internal/membership" */))
const _3271e2c5 = () => interopDefault(import('../src/pages/internal/news/index.vue' /* webpackChunkName: "pages/internal/news/index" */))
const _3409e746 = () => interopDefault(import('../src/pages/internal/ticketcheck.vue' /* webpackChunkName: "pages/internal/ticketcheck" */))
const _42cfb1f6 = () => interopDefault(import('../src/pages/internal/validate.vue' /* webpackChunkName: "pages/internal/validate" */))
const _94d28c70 = () => interopDefault(import('../src/pages/u/forgot-password.vue' /* webpackChunkName: "pages/u/forgot-password" */))
const _63a4aeec = () => interopDefault(import('../src/pages/u/login.vue' /* webpackChunkName: "pages/u/login" */))
const _10675972 = () => interopDefault(import('../src/pages/u/manage.vue' /* webpackChunkName: "pages/u/manage" */))
const _5ed0a0e3 = () => interopDefault(import('../src/pages/u/membership.vue' /* webpackChunkName: "pages/u/membership" */))
const _57b0f270 = () => interopDefault(import('../src/pages/u/register.vue' /* webpackChunkName: "pages/u/register" */))
const _6a70a2a2 = () => interopDefault(import('../src/pages/u/confirm/activate.vue' /* webpackChunkName: "pages/u/confirm/activate" */))
const _2c8cc219 = () => interopDefault(import('../src/pages/u/confirm/expired.vue' /* webpackChunkName: "pages/u/confirm/expired" */))
const _33108812 = () => interopDefault(import('../src/pages/u/confirm/success.vue' /* webpackChunkName: "pages/u/confirm/success" */))
const _0979ef2c = () => interopDefault(import('../src/pages/u/confirm/trigger.vue' /* webpackChunkName: "pages/u/confirm/trigger" */))
const _05e8528b = () => interopDefault(import('../src/pages/u/recover/activate.vue' /* webpackChunkName: "pages/u/recover/activate" */))
const _79cb9a86 = () => interopDefault(import('../src/pages/u/recover/expired.vue' /* webpackChunkName: "pages/u/recover/expired" */))
const _7d052c9b = () => interopDefault(import('../src/pages/u/recover/success.vue' /* webpackChunkName: "pages/u/recover/success" */))
const _650af92e = () => interopDefault(import('../src/pages/internal/event/_id/index.vue' /* webpackChunkName: "pages/internal/event/_id/index" */))
const _4033d26d = () => interopDefault(import('../src/pages/internal/news/_id.vue' /* webpackChunkName: "pages/internal/news/_id" */))
const _d1766d4a = () => interopDefault(import('../src/pages/internal/update-user/_id.vue' /* webpackChunkName: "pages/internal/update-user/_id" */))
const _1588df82 = () => interopDefault(import('../src/pages/internal/view/_id.vue' /* webpackChunkName: "pages/internal/view/_id" */))
const _d068e290 = () => interopDefault(import('../src/pages/u/confirm/_confirmId.vue' /* webpackChunkName: "pages/u/confirm/_confirmId" */))
const _e55aa8d8 = () => interopDefault(import('../src/pages/u/recover/_confirmId.vue' /* webpackChunkName: "pages/u/recover/_confirmId" */))
const _949cb6a8 = () => interopDefault(import('../src/pages/internal/event/_id/lists.vue' /* webpackChunkName: "pages/internal/event/_id/lists" */))
const _ed71dbbc = () => interopDefault(import('../src/pages/event/_id.vue' /* webpackChunkName: "pages/event/_id" */))
const _39056068 = () => interopDefault(import('../src/pages/internal/_404.vue' /* webpackChunkName: "pages/internal/_404" */))
const _439cda31 = () => interopDefault(import('../src/pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _a210f874 = () => interopDefault(import('../src/pages/u/_404.vue' /* webpackChunkName: "pages/u/_404" */))
const _6490ea2c = () => interopDefault(import('../src/pages/_404.vue' /* webpackChunkName: "pages/_404" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contribute",
    component: _cf143440,
    name: "contribute___it"
  }, {
    path: "/cookies",
    component: _7e74882c,
    name: "cookies___it"
  }, {
    path: "/cookies-en",
    component: _688fff1a,
    name: "cookies-en___it"
  }, {
    path: "/en",
    component: _d0df1ba2,
    name: "index___en"
  }, {
    path: "/events",
    component: _6c4d080c,
    name: "events___it"
  }, {
    path: "/internal",
    component: _51aac373,
    name: "internal___it"
  }, {
    path: "/privacy",
    component: _3db944a5,
    name: "privacy___it"
  }, {
    path: "/privacy-en",
    component: _ef0e77fe,
    name: "privacy-en___it"
  }, {
    path: "/refunds",
    component: _e7aa80d0,
    name: "refunds___it"
  }, {
    path: "/refunds-en",
    component: _104b802e,
    name: "refunds-en___it"
  }, {
    path: "/terms",
    component: _418e3064,
    name: "terms___it"
  }, {
    path: "/terms-en",
    component: _6f4ecbe2,
    name: "terms-en___it"
  }, {
    path: "/thankyou",
    component: _10241b28,
    name: "thankyou___it"
  }, {
    path: "/u",
    component: _cc05e856,
    name: "u___it"
  }, {
    path: "/where",
    component: _e3de1878,
    name: "where___it"
  }, {
    path: "/en/contribute",
    component: _cf143440,
    name: "contribute___en"
  }, {
    path: "/en/cookies",
    component: _7e74882c,
    name: "cookies___en"
  }, {
    path: "/en/cookies-en",
    component: _688fff1a,
    name: "cookies-en___en"
  }, {
    path: "/en/events",
    component: _6c4d080c,
    name: "events___en"
  }, {
    path: "/en/internal",
    component: _51aac373,
    name: "internal___en"
  }, {
    path: "/en/privacy",
    component: _3db944a5,
    name: "privacy___en"
  }, {
    path: "/en/privacy-en",
    component: _ef0e77fe,
    name: "privacy-en___en"
  }, {
    path: "/en/refunds",
    component: _e7aa80d0,
    name: "refunds___en"
  }, {
    path: "/en/refunds-en",
    component: _104b802e,
    name: "refunds-en___en"
  }, {
    path: "/en/terms",
    component: _418e3064,
    name: "terms___en"
  }, {
    path: "/en/terms-en",
    component: _6f4ecbe2,
    name: "terms-en___en"
  }, {
    path: "/en/thankyou",
    component: _10241b28,
    name: "thankyou___en"
  }, {
    path: "/en/u",
    component: _cc05e856,
    name: "u___en"
  }, {
    path: "/en/where",
    component: _e3de1878,
    name: "where___en"
  }, {
    path: "/internal/deletions",
    component: _0aaf8306,
    name: "internal-deletions___it"
  }, {
    path: "/internal/events",
    component: _15064170,
    name: "internal-events___it"
  }, {
    path: "/internal/export",
    component: _7385673a,
    name: "internal-export___it"
  }, {
    path: "/internal/home",
    component: _7bc9b9ce,
    name: "internal-home___it"
  }, {
    path: "/internal/list",
    component: _2e0d03e6,
    name: "internal-list___it"
  }, {
    path: "/internal/login",
    component: _1b52668a,
    name: "internal-login___it"
  }, {
    path: "/internal/membership",
    component: _808a07f6,
    name: "internal-membership___it"
  }, {
    path: "/internal/news",
    component: _3271e2c5,
    name: "internal-news___it"
  }, {
    path: "/internal/ticketcheck",
    component: _3409e746,
    name: "internal-ticketcheck___it"
  }, {
    path: "/internal/validate",
    component: _42cfb1f6,
    name: "internal-validate___it"
  }, {
    path: "/u/forgot-password",
    component: _94d28c70,
    name: "u-forgot-password___it"
  }, {
    path: "/u/login",
    component: _63a4aeec,
    name: "u-login___it"
  }, {
    path: "/u/manage",
    component: _10675972,
    name: "u-manage___it"
  }, {
    path: "/u/membership",
    component: _5ed0a0e3,
    name: "u-membership___it"
  }, {
    path: "/u/register",
    component: _57b0f270,
    name: "u-register___it"
  }, {
    path: "/en/internal/deletions",
    component: _0aaf8306,
    name: "internal-deletions___en"
  }, {
    path: "/en/internal/events",
    component: _15064170,
    name: "internal-events___en"
  }, {
    path: "/en/internal/export",
    component: _7385673a,
    name: "internal-export___en"
  }, {
    path: "/en/internal/home",
    component: _7bc9b9ce,
    name: "internal-home___en"
  }, {
    path: "/en/internal/list",
    component: _2e0d03e6,
    name: "internal-list___en"
  }, {
    path: "/en/internal/login",
    component: _1b52668a,
    name: "internal-login___en"
  }, {
    path: "/en/internal/membership",
    component: _808a07f6,
    name: "internal-membership___en"
  }, {
    path: "/en/internal/news",
    component: _3271e2c5,
    name: "internal-news___en"
  }, {
    path: "/en/internal/ticketcheck",
    component: _3409e746,
    name: "internal-ticketcheck___en"
  }, {
    path: "/en/internal/validate",
    component: _42cfb1f6,
    name: "internal-validate___en"
  }, {
    path: "/en/u/forgot-password",
    component: _94d28c70,
    name: "u-forgot-password___en"
  }, {
    path: "/en/u/login",
    component: _63a4aeec,
    name: "u-login___en"
  }, {
    path: "/en/u/manage",
    component: _10675972,
    name: "u-manage___en"
  }, {
    path: "/en/u/membership",
    component: _5ed0a0e3,
    name: "u-membership___en"
  }, {
    path: "/en/u/register",
    component: _57b0f270,
    name: "u-register___en"
  }, {
    path: "/u/confirm/activate",
    component: _6a70a2a2,
    name: "u-confirm-activate___it"
  }, {
    path: "/u/confirm/expired",
    component: _2c8cc219,
    name: "u-confirm-expired___it"
  }, {
    path: "/u/confirm/success",
    component: _33108812,
    name: "u-confirm-success___it"
  }, {
    path: "/u/confirm/trigger",
    component: _0979ef2c,
    name: "u-confirm-trigger___it"
  }, {
    path: "/u/recover/activate",
    component: _05e8528b,
    name: "u-recover-activate___it"
  }, {
    path: "/u/recover/expired",
    component: _79cb9a86,
    name: "u-recover-expired___it"
  }, {
    path: "/u/recover/success",
    component: _7d052c9b,
    name: "u-recover-success___it"
  }, {
    path: "/en/u/confirm/activate",
    component: _6a70a2a2,
    name: "u-confirm-activate___en"
  }, {
    path: "/en/u/confirm/expired",
    component: _2c8cc219,
    name: "u-confirm-expired___en"
  }, {
    path: "/en/u/confirm/success",
    component: _33108812,
    name: "u-confirm-success___en"
  }, {
    path: "/en/u/confirm/trigger",
    component: _0979ef2c,
    name: "u-confirm-trigger___en"
  }, {
    path: "/en/u/recover/activate",
    component: _05e8528b,
    name: "u-recover-activate___en"
  }, {
    path: "/en/u/recover/expired",
    component: _79cb9a86,
    name: "u-recover-expired___en"
  }, {
    path: "/en/u/recover/success",
    component: _7d052c9b,
    name: "u-recover-success___en"
  }, {
    path: "/",
    component: _d0df1ba2,
    name: "index___it"
  }, {
    path: "/en/internal/event/:id",
    component: _650af92e,
    name: "internal-event-id___en"
  }, {
    path: "/en/internal/news/:id",
    component: _4033d26d,
    name: "internal-news-id___en"
  }, {
    path: "/en/internal/update-user/:id?",
    component: _d1766d4a,
    name: "internal-update-user-id___en"
  }, {
    path: "/en/internal/view/:id?",
    component: _1588df82,
    name: "internal-view-id___en"
  }, {
    path: "/en/u/confirm/:confirmId?",
    component: _d068e290,
    name: "u-confirm-confirmId___en"
  }, {
    path: "/en/u/recover/:confirmId?",
    component: _e55aa8d8,
    name: "u-recover-confirmId___en"
  }, {
    path: "/en/internal/event/:id?/lists",
    component: _949cb6a8,
    name: "internal-event-id-lists___en"
  }, {
    path: "/en/event/:id?",
    component: _ed71dbbc,
    name: "event-id___en"
  }, {
    path: "/en/internal/:404",
    component: _39056068,
    name: "internal-404___en"
  }, {
    path: "/en/news/:id?",
    component: _439cda31,
    name: "news-id___en"
  }, {
    path: "/en/u/:404",
    component: _a210f874,
    name: "u-404___en"
  }, {
    path: "/internal/event/:id",
    component: _650af92e,
    name: "internal-event-id___it"
  }, {
    path: "/internal/news/:id",
    component: _4033d26d,
    name: "internal-news-id___it"
  }, {
    path: "/internal/update-user/:id?",
    component: _d1766d4a,
    name: "internal-update-user-id___it"
  }, {
    path: "/internal/view/:id?",
    component: _1588df82,
    name: "internal-view-id___it"
  }, {
    path: "/u/confirm/:confirmId?",
    component: _d068e290,
    name: "u-confirm-confirmId___it"
  }, {
    path: "/u/recover/:confirmId?",
    component: _e55aa8d8,
    name: "u-recover-confirmId___it"
  }, {
    path: "/internal/event/:id?/lists",
    component: _949cb6a8,
    name: "internal-event-id-lists___it"
  }, {
    path: "/en/:404",
    component: _6490ea2c,
    name: "404___en"
  }, {
    path: "/event/:id?",
    component: _ed71dbbc,
    name: "event-id___it"
  }, {
    path: "/internal/:404",
    component: _39056068,
    name: "internal-404___it"
  }, {
    path: "/news/:id?",
    component: _439cda31,
    name: "news-id___it"
  }, {
    path: "/u/:404",
    component: _a210f874,
    name: "u-404___it"
  }, {
    path: "/:404",
    component: _6490ea2c,
    name: "404___it"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
